export const BOOK_APPOINTMENT_MODAL_CLOSE = 'book-appointment-modal-close';
export const BOOK_APPOINTMENT_MODAL_OPEN_BTN = 'book-appointment-modal-open-btn';
export const BOOK_APPOINTMENT_MODULE_NAME = 'bookAppointment';
